import React from "react";
import "../../css_files/Enquiry/EnquiryInfo.css";
import CloseForm from "../Master/CloseForm";

function EnquiryInfo({ enquiryinfodata, setshowenquiryInfo }) {
  return (
    <section className="enquiry-info">
      {enquiryinfodata && (
        <div>
          <h1>Enquiry Detail</h1>
          <p>
            <strong>Enquiry Id: </strong>
            {enquiryinfodata.seriesID}
          </p>
          <p>
            <strong>Company/Organization Name: </strong>
            {enquiryinfodata.customer.orgName}
          </p>
          <p>
            <strong>
              {enquiryinfodata.isAddressSame
                ? "Shipping Address / Billing Address"
                : "Shipping Address"}
              :{" "}
            </strong>
            {enquiryinfodata.shipToAddress.addressType}:{" "}
            {enquiryinfodata.shipToAddress.officeName ||
              enquiryinfodata.shipToAddress.factoryName}
            ,{enquiryinfodata.shipToAddress.address1},{" "}
            {enquiryinfodata.shipToAddress.address2},{" "}
            {enquiryinfodata.shipToAddress?.cityObj?.name ||
              enquiryinfodata.shipToAddress?.cityName}
            ,{" "}
            {enquiryinfodata.shipToAddress?.stateObj?.name ||
              enquiryinfodata.shipToAddress?.stateName}
            , {enquiryinfodata.shipToAddress.country},{" "}
            {enquiryinfodata.shipToAddress.pincode}
          </p>
          {enquiryinfodata.isAddressSame === false && (
            <p>
              <strong>Billing Address: </strong>
              {enquiryinfodata.billToAddress.addressType}:{" "}
              {enquiryinfodata.billToAddress.officeName ||
                enquiryinfodata.billToAddress.factoryName}
              ,{enquiryinfodata.billToAddress.address1},{" "}
              {enquiryinfodata.billToAddress.address2},{" "}
              {enquiryinfodata.billToAddress?.cityObj?.name ||
                enquiryinfodata.billToAddress?.cityName}
              ,{" "}
              {enquiryinfodata.billToAddress?.stateObj?.name ||
                enquiryinfodata.billToAddress?.stateName}
              , {enquiryinfodata.billToAddress.country},{" "}
              {enquiryinfodata.billToAddress.pincode}
            </p>
          )}
          <p>
            <strong>Customer Name: </strong>
            {enquiryinfodata.contactCentre.name}
          </p>
          <p>
            <strong>Customer Email: </strong>
            {enquiryinfodata.contactCentre.email}
          </p>
          <p>
            <strong>Customer Phone Number: </strong>
            {enquiryinfodata.contactCentre.phoneNumber}
          </p>
          <p>
            <strong>Customer Boiler: </strong>
            {enquiryinfodata.customerBoiler.boilerHead},{" "}
            {enquiryinfodata.customerBoiler.boilerSeries}
          </p>
          <p>
            <strong>Enquiry Type: </strong>
            {enquiryinfodata.enquiryType}
          </p>
          <p>
            <strong>Date of Enquiry: </strong>
            {new Date(enquiryinfodata.dateOfEnquiry).toDateString()}
          </p>
          <p>
            <strong>Priority: </strong>
            {enquiryinfodata.priority}
          </p>
          <p>
            <strong>Ticket Created: </strong>
            {enquiryinfodata.isTicketCreated ? "Yes" : "No"}
          </p>
          <p>
            <strong>
              {enquiryinfodata.enquiryType === "Service"
                ? "Services"
                : enquiryinfodata.enquiryType}{" "}
              Looking For:{" "}
            </strong>
            {enquiryinfodata.servicesLookingFor}
          </p>
          <CloseForm close={setshowenquiryInfo} />
        </div>
      )}
    </section>
  );
}

export default EnquiryInfo;
